// extracted by mini-css-extract-plugin
module.exports = {"select":"select_select__1sfRQ","selectnoOutline":"select_selectnoOutline__EM4l_"};